export const CHANGE_COLOR_SETTING = 'CHANGE_COLOR_SETTING';
export const CHANGE_TYPOGRAPHY_SETTING = 'CHANGE_TYPOGRAPHY_SETTING';
export const CHANGE_SECTION_SETTING = 'CHANGE_SECTION_SETTING';
export const CHANGE_TEMPLATE_SETTING = 'CHANGE_TEMPLATE_SETTING';
